/* ===== Component: Layout – MainLayout ===== */
import { ReactNode } from 'react';
import Header from './Header';
import Footer from './Footer';
interface MainLayoutProps {
  children: ReactNode;
}
const MainLayout = ({
  children
}: MainLayoutProps) => {
  return <div className="flex flex-col min-h-screen bg-[AFFFCE] bg-[#afffce]/[0.14]">
      <Header />
      <main className="flex-grow bg-[AFFFCE]">{children}</main>
      <Footer />
    </div>;
};
export default MainLayout;